/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReportConfigRequest
 */
export interface UpdateReportConfigRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReportConfigRequest
     */
    favourite: boolean;
}

/**
 * Check if a given object implements the UpdateReportConfigRequest interface.
 */
export function instanceOfUpdateReportConfigRequest(value: object): value is UpdateReportConfigRequest {
    if (!('favourite' in value) || value['favourite'] === undefined) return false;
    return true;
}

export function UpdateReportConfigRequestFromJSON(json: any): UpdateReportConfigRequest {
    return UpdateReportConfigRequestFromJSONTyped(json, false);
}

export function UpdateReportConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReportConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'favourite': json['favourite'],
    };
}

export function UpdateReportConfigRequestToJSON(json: any): UpdateReportConfigRequest {
    return UpdateReportConfigRequestToJSONTyped(json, false);
}

export function UpdateReportConfigRequestToJSONTyped(value?: UpdateReportConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'favourite': value['favourite'],
    };
}

